import React from 'react';
import classNames from 'classnames';

import './OptionMenuButton.css';

export const OptionMenuButtonIconAndText = ({ icon, children }) => (
  <span className="OptionMenuButton__icon-and-text">
    {icon && <span className="OptionMenuButton__icon">{icon}</span>}
    <span className="OptionMenuButton__text">{children}</span>
  </span>
);

const OptionMenuButton = ({ children, onClick, selected, tooltipProps = {} }) => {
  const optionMenuCssClassnames = classNames('OptionMenuButton', {
    'OptionMenuButton--selected': selected
  });

  return (
    <button className={optionMenuCssClassnames} onClick={onClick} {...tooltipProps}>
      {children}
    </button>
  );
};

export default OptionMenuButton;
